import { render } from "./Events.vue?vue&type=template&id=5a6d4d94&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=5a6d4d94&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6d4d94"]])

export default __exports__